var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFourthPending(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 1.5,
    width: 49,
    height: 49,
    rx: 24.5,
    stroke: "white",
    strokeWidth: 3
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2501_18805)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18 36.6667V34C18 31.8783 18.8429 29.8434 20.3431 28.3431C21.8434 26.8429 23.8783 26 26 26C28.1217 26 30.1566 26.8429 31.6569 28.3431C33.1571 29.8434 34 31.8783 34 34V36.6667C34 37.0203 33.8595 37.3594 33.6095 37.6095C33.3594 37.8595 33.0203 38 32.6667 38H19.3333C18.9797 38 18.6406 37.8595 18.3905 37.6095C18.1405 37.3594 18 37.0203 18 36.6667Z",
    stroke: "white",
    strokeWidth: 2.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 15.3333V18C18 20.1217 18.8429 22.1566 20.3431 23.6569C21.8434 25.1571 23.8783 26 26 26C28.1217 26 30.1566 25.1571 31.6569 23.6569C33.1571 22.1566 34 20.1217 34 18V15.3333C34 14.9797 33.8595 14.6406 33.6095 14.3905C33.3594 14.1405 33.0203 14 32.6667 14H19.3333C18.9797 14 18.6406 14.1405 18.3905 14.3905C18.1405 14.6406 18 14.9797 18 15.3333V15.3333Z",
    stroke: "white",
    strokeWidth: 2.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2501_18805"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(10 10)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFourthPending);
export default __webpack_public_path__ + "static/media/fourthPending.05ca56054e372fb953c4b67a60e424b4.svg";
export { ForwardRef as ReactComponent };